import { render, staticRenderFns } from "./fractionLook.vue?vue&type=template&id=85b1d12c&scoped=true&"
import script from "./fractionLook.vue?vue&type=script&lang=js&"
export * from "./fractionLook.vue?vue&type=script&lang=js&"
import style0 from "./fractionLook.vue?vue&type=style&index=0&id=85b1d12c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b1d12c",
  null
  
)

export default component.exports